import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const longtermRequests = {
        isLoading: false,
        init() {
            $(document).on('click', '.longterm-select-model-btn', this, this.selectModel);
            $(document).on('click', '#longterm-submit-form', this, this.send);
        },
		selectModel(event) {
			const _this = event.data;

			$('#model').val($(this).data('model'));

			$('html, body').animate({
				scrollTop: $('#request-offer').offset().top - 75
			}, 100);
		},
		send(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('.longterm-requests-form').find('.form-control').removeClass('is-invalid');
			$('.longterm-requests-form').find('.form-check-input').removeClass('is-invalid');

			if ($('#first_name').val() == '') {
				$('#first_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#last_name').val() == '') {
				$('#last_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#model').val() == '') {
				$('#model').addClass('is-invalid');
				errors = true;
			}
			// if (!$('#terms_and_conditions_' + offerId).is(":checked")) {
			// 	$('#terms_and_conditions_' + offerId).addClass('is-invalid');
			// 	errors = true;
			// }

			if (errors) {
				Swal.fire({
					icon: 'error',
					title: 'Error!',
					html: $(this).data('alert-text')
				});
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'model=' + $('#model').val();
			values += '&first_name=' + $('#first_name').val();
			values += '&last_name=' + $('#last_name').val();
			values += '&phone=' + $('#phone').val();
			values += '&email=' + $('#email').val();
			values += '&message=' + $('#message').val();
			values += '&_token=' + $('meta[name="csrf-token"]').attr('content');
			$.ajax({
				type: "POST",
				url: baseURL + "/longterm-requests/send",
				data: values,
				success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }

						Swal.fire({
							icon: 'error',
							title: 'Error!',
							html: $(element).data('alert-text')
						});
                        return false;
                    }

					if (response.status == 1) {
						$('.longterm-requests-form').find('.form-control').val('');
						//$('#terms_and_conditions_' + offerId).prop('checked', false);

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						return false;
					}

					Swal.fire({
						icon: 'error',
						title: 'Error!',
						html: response.message
					});
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

	if ( $('.longterm-requests-form').length ) {
        longtermRequests.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/longterm-requests.js